import React from "react"
import SocialLinks from "./SocialLinks";
const Footer = () => {
    return (
        <footer className="footer">
            <div>
                <SocialLinks styleClass="footer-links"></SocialLinks>
                <h4>copyright & 2020
                    <span> Riya Shah </span> all rights reserved
                </h4>
            </div>
        </footer>
    )
}

export default Footer
